"use strict";

var _slicedToArray = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BufferMap = void 0;

var buffer_string_1 = require("./buffer_string");

var cloneDeep = require("lodash.clonedeep");

var BufferMap = /*#__PURE__*/function () {
  function BufferMap(data) {
    _classCallCheck(this, BufferMap);

    this._data = {};
    this._data = data !== null && data !== void 0 ? data : {};
  }

  _createClass(BufferMap, [{
    key: "get",
    value: function get(key) {
      return this._data[buffer_string_1.keyString(key)];
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      delete this._data[buffer_string_1.keyString(key)];
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this._data[buffer_string_1.keyString(key)] = value;
    }
  }, {
    key: "has",
    value: function has(key) {
      return this._data[buffer_string_1.keyString(key)] !== undefined;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new BufferMap(cloneDeep(this._data));
    }
  }, {
    key: "entries",
    value: function entries() {
      return Object.entries(this._data).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return [Buffer.from(key, 'binary'), value];
      });
    }
  }, {
    key: "values",
    value: function values() {
      return Object.values(this._data);
    }
  }, {
    key: "size",
    get: function get() {
      return Object.keys(this._data).length;
    }
  }]);

  return BufferMap;
}();

exports.BufferMap = BufferMap;